import React from 'react'
import ReactDOM from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import {
    Route,
    Routes,
    unstable_HistoryRouter as HistoryRouter,
} from 'react-router-dom'

import axiosAuth from './api/axiosAuth'
import i18next from './i18n/config'
import history from './router/CustomHistory'
import { getConfiguration, loadAppConfiguration } from './utils/config'
import App from './App'

import './styles/styles.scss'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

loadAppConfiguration().then(() => {
    const { backendUrl } = getConfiguration()
    // Must be set after loadAppConfiguration()
    axiosAuth.defaults.baseURL = backendUrl

    root.render(
        <I18nextProvider i18n={i18next}>
            {/* @ts-expect-error react-router-dom expects history type from @remix-run/router */}
            <HistoryRouter history={history}>
                <Routes>
                    <Route path="*" element={<App />} />
                </Routes>
            </HistoryRouter>
        </I18nextProvider>
    )
})
